
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samples/spacing",
      function () {
        return require("private-next-pages/samples/spacing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samples/spacing"])
      });
    }
  